import React from 'react';

export const HamburgerIcon = ({
  className,
}: {
  className?: string;
}): JSX.Element => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='currentColor'
    fillRule='evenodd'
    clipRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    className={className}
  >
    <path d='M0 13.5H15V12H0V13.5ZM0 3.5H15V2H0V3.5ZM15 8.5H0V7H15V8.5Z' />
  </svg>
);
